var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "3", align: "right" } }, [
        _c("label", { staticClass: "mt-2", attrs: { for: _vm.propertyKey } }, [
          _vm._v("\n      " + _vm._s(_vm.label) + ":\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "7" } },
        [
          !_vm.isEditing
            ? _c(
                "button",
                {
                  staticClass: "btn border-0 flex-grow-1 text-left shadow-none",
                  attrs: { type: "button" },
                  on: { click: _vm.editProperty }
                },
                [
                  _vm.propertyValue
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.isSensitive ? "********" : _vm.propertyValue
                          )
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.propertyValue && _vm.placeholder
                    ? _c("span", [_c("em", [_vm._v(_vm._s(_vm.placeholder))])])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditing
            ? _c(
                "b-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.updateProperty($event)
                    }
                  }
                },
                [
                  _vm.isEditing
                    ? _c("b-form-input", {
                        ref: "propertyInput",
                        attrs: {
                          id: _vm.propertyKey,
                          placeholder: _vm.placeholder,
                          size: "sm",
                          type: "text"
                        },
                        model: {
                          value: _vm.value,
                          callback: function($$v) {
                            _vm.value =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "value"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "2" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-primary border-0",
            attrs: { type: "button" },
            on: { click: _vm.editProperty }
          },
          [
            !_vm.isEditing
              ? _c("span", { staticClass: "fa fa-edit" })
              : _vm._e(),
            _vm._v(" "),
            _vm.isEditing ? _c("span", { staticClass: "fa fa-save" }) : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-outline-danger border-0",
            attrs: { type: "button" },
            on: { click: _vm.deleteProperty }
          },
          [_c("span", { staticClass: "fa fa-trash" })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }